import api from '@/api/fetch'
import type { Device, DeviceConfig } from '@/types/device'

export async function addDevice(device: Device): Promise<DeviceConfig> {
  return api
    .put<DeviceConfig>(`/devices/${device.id}`, { ...device, deleted: false })
    .then(res => res.data)
}
